export const ValidateMessageMapper = {
  fieldEmpty: "Este campo é obrigatório.",
  nameEmpty: "O nome é obrigatório.",
  nameInvalid: "Digite um nome válido (apenas letras e espaços).",
  emailEmpty: "O e-mail é obrigatório.",
  emailTooLong: "O e-mail é muito longo.",
  emailInvalid: "Digite um e-mail válido.",
  messageEmpty: "A mensagem é obrigatória.",
  messageTooShort: "A mensagem deve ter no mínimo 10 caracteres.",
} as const;
